const FEATURES = [
  {
    id: 1,
    icon: 'ri-stack-line',
    title: '多平台资源聚合',
    desc: '一站汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等多个平台的热门影视资源，告别多站切换的烦恼，海量内容尽在掌握。',
    color: 'text-primary-600 bg-primary-100',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清流畅不缓冲',
    desc: '采用先进播放优化技术，全站资源高清画质秒开秒播，即便在网络波动环境下也能保持流畅观影体验，追剧零等待。',
    color: 'text-accent-600 bg-accent-100',
  },
  {
    id: 3,
    icon: 'ri-calendar-check-line',
    title: '每日更新不断档',
    desc: '专业内容运营团队全天候跟进最新资源，新剧上线、剧集更新、电影首发，每天都有新鲜内容等你来发现。',
    color: 'text-secondary-600 bg-secondary-100',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100/70 text-secondary-700 text-xs font-medium mb-3">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-2">优势特色</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            玫瑰视频为你打造极致追剧体验的核心优势
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {FEATURES.map((feature) => (
            <div
              key={feature.id}
              className="flex flex-col items-center text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl ${feature.color} flex items-center justify-center mb-5`}>
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-lg font-heading text-foreground-950 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}